// extracted by mini-css-extract-plugin
export default {"tabs":"nds8lxsO+H"};